import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

// This validator prevents you from entering only white spaces in the input field.
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const hasWhitespace =
      (control.value && control.value.trim().length === 0) ||
      /\s+/.test(control.value);
    return hasWhitespace ? { whitespace: true } : null;
  };
}
